import { type FC } from "react";
import Card from "~/common/components/Card";
import { type TileData } from "~/features/myAccount/dashboard/type";
import { useTranslation } from "react-i18next";

export const tileBuilder = (tiles: TileData[]) => {
  return tiles.map((tile, i) => <AccountSettingsTile key={i} {...tile} />);
};

const AccountSettingsTile: FC<TileData> = ({ url, title, description, testId }) => {
  const { t } = useTranslation();
  const titleLoc = t(title);
  const descriptionLoc = t(description ?? "");
  return (
    <a
      href={url}
      data-test-id={testId}
      title={titleLoc}
      className="f-carbon-hover-focus scha__account-settings__section__tile"
    >
      <Card className="p-3">
        <h4 className="m-0 title-medium mb-2 f-bold">{titleLoc}</h4>
        <p className="m-0 label-large">{descriptionLoc}</p>
      </Card>
    </a>
  );
};
